import { Col, Modal, Row, Table } from 'antd';
import { useUnit } from 'effector-react';
import { Bar, Column } from '@ant-design/charts';
import {
  $okedsModalsFilters,
  $regionData,
  $regionModal,
  changeDistrictModalEv,
  changeOkedsModalsFiltersEv,
  changeSubOkedsModalEv,
  RegionModalGate,
  resetRegionModalEv,
} from '../../models/investProjectsModel/index.js';
import { useState } from 'react';

function InvestRegionModal() {
  const regionModal = useUnit($regionModal);
  const resetRegionModal = useUnit(resetRegionModalEv);
  const changeDistrictModal = useUnit(changeDistrictModalEv);
  const changeSubOkedsModal = useUnit(changeSubOkedsModalEv);
  const regionData = useUnit($regionData);

  const modalFilters = useUnit($okedsModalsFilters);
  const setModalFilters = useUnit(changeOkedsModalsFiltersEv);

  const [zoomChart, setZoomChart] = useState({ chart: null, zoom: false });
  const onZoomChange = (newChart) => {
    setZoomChart((prev) => ({
      chart: newChart,
      zoom: prev.chart === newChart ? !prev.zoom : true,
    }));
  };

  const districtsKPIColumns = [
    {
      title: '№',
      key: 'disctirct_num',
      dataIndex: 'num',
    },
    {
      title: 'Район',
      key: 'disctirct_disctirct',
      dataIndex: 'region',
    },
    {
      title: 'KPI-1',
      key: 'disctirct_kpi_1',
      dataIndex: 'kpi_1',
    },
    {
      title: 'KPI-2',
      key: 'disctirct_kpi_2',
      dataIndex: 'kpi_2',
    },
  ];

  const okedsKPIColumns = [
    {
      title: '№',
      key: 'okeds_num',
      dataIndex: 'num',
    },
    {
      title: 'Вид деятельности',
      key: 'okeds_activity',
      dataIndex: 'activity',
    },
    {
      title: 'KPI-1',
      key: 'okeds_kpi_1',
      dataIndex: 'kpi_1',
    },
    {
      title: 'KPI-2',
      key: 'okeds_kpi_2',
      dataIndex: 'kpi_2',
    },
  ];

  const quarterKPIConfig = {
    data: regionData?.quarter_kpi || [],
    isGroup: true,
    xField: 'quarter',
    yField: 'value',
    seriesField: 'type',
    label: {
      position: 'middle',
      layout: [
        {
          type: 'interval-adjust-position',
        },
        {
          type: 'interval-hide-overlap',
        },
        {
          type: 'adjust-color',
        },
      ],
    },
  };
  const regionBarConfig = {
    isStack: true,
    xField: 'value',
    seriesField: 'phase',
    label: {
      position: 'middle',
      layout: [
        {
          type: 'interval-adjust-position',
        },
        {
          type: 'interval-hide-overlap',
        },
        {
          type: 'adjust-color',
        },
      ],
    },
  };

  return (
    <Modal
      zIndex={102}
      open={!!regionModal}
      onCancel={(e) => {
        e.stopPropagation();
        setModalFilters({ region_id: null });
        resetRegionModal();
      }}
      footer={null}
      width="80vw"
      destroyOnClose
    >
      <RegionModalGate />
      {regionData && (
        <Row gutter={[16, 16]}>
          <Col
            span={zoomChart.chart === 1 && zoomChart.zoom ? 12 : 8}
            order={zoomChart.chart === 1 && zoomChart.zoom ? 2 : 1}
          >
            <Table
              columns={districtsKPIColumns}
              pagination={false}
              rowClassName={'pointer'}
              rowKey={'id'}
              rowSelection={{
                hideSelectAll: true,
                selections: true,
                selectedRowKeys: modalFilters.district_id
                  ? [modalFilters.district_id]
                  : [],
                onChange: (keys) => {
                  setModalFilters({
                    district_id: keys?.length > 0 ? keys?.at(-1) : null,
                  });
                },
              }}
              onRow={(record) => {
                return {
                  onClick: (e) => {
                    setModalFilters({ district_id: record.id });
                    changeDistrictModal({ district: record.id });
                  },
                };
              }}
              dataSource={regionData.district_kpi}
            />
          </Col>
          <Col
            span={zoomChart.chart === 1 && zoomChart.zoom ? 24 : 8}
            order={zoomChart.chart === 1 && zoomChart.zoom ? 1 : 2}
          >
            <Column
              {...quarterKPIConfig}
              onReady={(plot) => {
                plot.on('plot:click', () => {
                  onZoomChange(1);
                });
              }}
            />
          </Col>
          <Col
            span={zoomChart.chart === 1 && zoomChart.zoom ? 12 : 8}
            order={3}
          >
            <Table
              columns={okedsKPIColumns}
              pagination={false}
              rowClassName={'pointer'}
              rowKey={'id'}
              rowSelection={{
                hideSelectAll: true,
                selections: true,
                selectedRowKeys: modalFilters.activity_id
                  ? [modalFilters.activity_id]
                  : [],
                onChange: (keys) => {
                  setModalFilters({
                    activity_id: keys?.length > 0 ? keys?.at(-1) : null,
                  });
                },
              }}
              onRow={(record) => {
                return {
                  onClick: (e) => {
                    setModalFilters({
                      activity_id: record.id,
                    });
                    changeSubOkedsModal(record);
                  },
                };
              }}
              dataSource={regionData.activity_kpi}
            />
          </Col>
          <Col
            span={zoomChart.chart === 2 && zoomChart.zoom ? 24 : 12}
            order={zoomChart.chart === 3 && zoomChart.zoom ? 5 : 4}
          >
            <Bar
              data={regionData.projects_by_district}
              yField="district"
              onReady={(plot) => {
                plot.on('plot:click', () => {
                  onZoomChange(2);
                });
              }}
              color={[
                'rgb(249,228,91)',
                'rgb(110, 147, 243)',
                'rgb(148,255,92)',
              ]}
              {...regionBarConfig}
            />
          </Col>
          <Col
            span={zoomChart.chart === 3 && zoomChart.zoom ? 24 : 12}
            order={zoomChart.chart === 3 && zoomChart.zoom ? 4 : 5}
          >
            <Bar
              data={regionData.projects_by_activity}
              yField="activity"
              onReady={(plot) => {
                plot.on('plot:click', () => {
                  onZoomChange(3);
                });
              }}
              color={[
                'rgb(249,228,91)',
                'rgb(110, 147, 243)',
                'rgb(148,255,92)',
              ]}
              {...regionBarConfig}
            />
          </Col>
        </Row>
      )}
    </Modal>
  );
}

export default InvestRegionModal;
